import { resizeObservers as r } from "./highrise1820.mjs";
var n = function() {
  return r.some(function(e) {
    return e.activeTargets.length > 0;
  });
};
export {
  n as hasActiveObservations
};
